    <template>
        <div class="ele-body">
            <el-card shadow="never" body-style="padding-top: 5px;">
                <!-- 编辑弹窗 -->
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                   <!-- <el-form-item label="分销状态:" prop="status">
                        <el-select v-model="editForm.status" filterable placeholder="请选择分销状态">
                            <el-option label="需要审核" value="1"></el-option>
                            <el-option label="全员分销" value="2"></el-option>
                        </el-select>
                    </el-form-item> -->
                   <!-- <el-form-item label="返现模式:" prop="retail_status">
                        <el-select v-model="editForm.retail_status" filterable placeholder="请选择返现模式">
                            <el-option label="现金" value="1"></el-option>
                            <el-option label="积分" value="2"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="邀请新人积分:" prop="invite_num">
                        <el-input-number v-model="editForm.invite_num" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入邀请新人积分" clearable />
                    </el-form-item>
                   <!-- <el-form-item label="邀请好友下单:" prop="invite_order_num">
                        <el-input-number v-model="editForm.invite_order_num" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入邀请好友下单" clearable />
                    </el-form-item> -->
                    <el-form-item label="一级订单返佣%:" prop="order_num">
                        <el-input-number v-model="editForm.order_num" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入一级订单返佣%" clearable />
                    </el-form-item>
                    <el-form-item label="二级订单返佣%:" prop="order_num1">
                        <el-input-number v-model="editForm.order_num1" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入二级订单返佣%" clearable />
                    </el-form-item>
                    <el-form-item label="一级订单返佣%:" prop="custom_num">
                        <el-input-number v-model="editForm.custom_num" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入一级订单返佣%" clearable />
                    </el-form-item>
                    <el-form-item label="二级订单返佣%:" prop="custom_num1">
                        <el-input-number v-model="editForm.custom_num1" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入二级订单返佣%" clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="save">保存更改</el-button>
                    </el-form-item>
                </el-form>

            </el-card>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";


        export default {
            name: "SysRetailConf",
            components: {},
            data() {
                return {
                    table: {
                        url: '/retail/RetailConf/index',
                        where: {}
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {}, // 表单数据
                    editFormTemp: {},
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    editRules: { // 表单验证规则

                        status: [{
                            required: true,
                            message: '请选择分销状态',
                            trigger: 'blur'
                        }],


                        retail_status: [{
                            required: true,
                            message: '请选择返现模式',
                            trigger: 'blur'
                        }],


                        invite_num: [{
                            required: true,
                            message: '请输入邀请新人积分',
                            trigger: 'blur'
                        }],


                        invite_order_num: [{
                            required: true,
                            message: '请输入邀请好友下单',
                            trigger: 'blur'
                        }],


                        order_num: [{
                            required: true,
                            message: '请输入下单积分',
                            trigger: 'blur'
                        }],


                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {
                this.edit();
            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit() {
                    this.$http.get('/retail/RetailConf/info?id=1').then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/retail/RetailConf/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的分销吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/retail/RetailConf/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/retail/RetailConf/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/retail/RetailConf/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },


            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>